import { atom } from "recoil";
import { ChannelConnectionType } from "../api/chatApi";

export const userWebChatAtom = atom<ChannelConnectionType | undefined>({
  key: "userWebChat",
  default: undefined,
});